
import {combineLatest as observableCombineLatest,  Observable } from 'rxjs';

import {map} from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MemberResponseInterface } from '@careapp/angular-sdk';
import { Store } from '@ngrx/store';

import * as actions from '../../store/actions/index';
import * as selectors from '../../store/reducers/index';

@Component({
  templateUrl: './staff.component.html',
  selector: 'ca-staff'
})
export class StaffComponent implements OnInit {
  admin$: Observable<boolean>;
  loading$: Observable<boolean>;
  staff$: Observable<MemberResponseInterface>;
  isOwnAccount$: Observable<boolean>;

  constructor(private store: Store<any>, public route: ActivatedRoute) {}

  ngOnInit() {
    const id = this.route.snapshot.params.id;
    this.store.dispatch(actions.Staff.SelectByIdAction({ id }));
    this.store.dispatch(actions.Staff.RequestByIdAction({ id }));
    this.loading$ = this.store
      .select(selectors.getLoadingEntities(selectors.STAFF)).pipe(
      map(loading => loading[id]));
    this.staff$ = this.store.select(selectors.getSelected(selectors.STAFF));
    this.admin$ = this.store.select(selectors.isOrgAdmin);
    this.isOwnAccount$ = observableCombineLatest(
      this.staff$,
      this.store.select(selectors.getAuthenticationState)
    ).pipe(map(([staff, auth]) => (staff ? auth.auth && staff.id === auth.auth.userId : false)));
  }

  submitStaff(payload: any) {
    this.store.dispatch(
      actions.Staff.RequestUpdateRole({ id: this.route.snapshot.params.id, role: payload })
    );
  }
}
